import { Node } from "../../graph/lib/node";
import { Grid } from "../../graph/lib/grid";

//Deprecated
export abstract class TreeNode extends Node{
    
    protected parent: TreeNode;
    protected content: any[];
    protected fakeContent: any[];
    protected alphabet: any[];
    protected depth: number;
    protected hideContent: boolean = false;
    protected textMaxWidthCol: number;
   
   //COLORS
    protected selectColor: string = "blue";
    protected standardColor: string = "black";
    protected currentColor: string = this.standardColor;

    constructor(rowIndex: number, colIndex: number, id: number, 
        parent:TreeNode, content: any[], alphabet: any[], depth: number){
        super(rowIndex,colIndex,id);
        this.parent = parent;
        this.alphabet = alphabet;
        this.depth = depth;
        this.content = content;
        this.fakeContent = [];
    }

    abstract inParameter(e:MouseEvent, grid:Grid);

    resetColor(){
        this.currentColor = this.standardColor;
    }

    selected(){
        this.currentColor = this.selectColor;
    }

    isSelected(): boolean{
        return this.currentColor == this.selectColor;
    }

    getParent():TreeNode{
        return this.parent;
    }

    getDepth():number{
        return this.depth;
    }

    addChildren(child: TreeNode){
        this.addNeighbor(child);
    }

    getAlphabet(): any[]{
        return this.alphabet;
    }

    getContent():any[]{
        return this.content;
    }

    getFakeContent():any[]{
        return this.fakeContent;
    }

    isHidden():boolean{
        return this.hideContent;
    }

    setHidden(hidden: boolean){
        this.hideContent = hidden;
    }

    abstract draw(ctx: CanvasRenderingContext2D, grid: Grid);



    setMaxTextWidth(maxWidthInCols: number){
        this.textMaxWidthCol = maxWidthInCols;
    }


}

